// import: styles
import { Box } from '@mui/material';
import { feedPromptsModalStyles } from 'apps/studio/studio-tab/components/feed-prompts-modal/FeedPromptsModalStyles';
import BaseTextField from 'core/components/textField/BaseTextField';

// import: assets
// import: config
// import: constants
// import: utils
// import: redux
// import: components
import BaseTypography from 'core/components/typography/BaseTypography';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import * as React from 'react';

// import: lazy load components

function FeedPromptsModalTextFieldInput({
	id,
	title,
	subtitle,
	placeholder,
	characterLimit = 100,
	value,
	onChangeFunc,
}) {
	return (
		<Box
			id={`${id}-input-section`}
			sx={[reusableStyles.flexCol, { alignItems: 'start', gap: '4px' }]}
			onKeyDown={(e) => e.stopPropagation()}
		>
			<BaseTypography variant="b2_caption_medium" styles={{ color: 'colors.light3' }}>
				{title}
			</BaseTypography>
			<BaseTypography variant="b2_caption" styles={{ color: 'colors.light4' }}>
				{subtitle}
			</BaseTypography>
			<Box
				component="form"
				noValidate
				autoComplete="off"
				sx={feedPromptsModalStyles.textFieldInputForm}
			>
				<BaseTextField
					id="feed-prompts-modal-text-field"
					name="feed-prompts-modal-text-field"
					fullWidth
					variant="standard"
					placeholder={placeholder}
					InputProps={{ disableUnderline: true }}
					/* eslint-disable-next-line react/jsx-no-duplicate-props */
					inputProps={{ maxLength: characterLimit }}
					styles={feedPromptsModalStyles.textFieldInput}
					value={value}
					onChange={onChangeFunc}
				/>
			</Box>
		</Box>
	);
}

export default FeedPromptsModalTextFieldInput;
